import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  insightList: [],
  pinnedList: [],
  pendingActions: [],
  selectedAnnomly: {
    preview: {},
    details: {},
  },
  selectedPlan: {},
  selectedApprovalRequest: {
    preview: {},
    details: {},
  },
  processList: [],
  selectedProcess: {},
  agentList: [],
  selectedAgent: {},
  recentAgents: [] as any[],
  biPortalRecentMenu: [],
  biPortalAllMenu: [],
  biPortalBucketWithDashboard: [],
  biPortalBucket: [],
  biPortalDashboard: [],
  biPortalCanvas: null,
  biPortalCanvasTemplateID: null,
  show_welcome_agent_hood: 1,
};

const biPortalSlice = createSlice({
  name: "biPortal",
  initialState,
  reducers: {
    getInsightList: (state, action) => {
      state.insightList = action.payload;
    },
    getPinnedList: (state, action) => {
      state.pinnedList = action.payload;
    },
    setWelcomePreference: (state, action) => {
      state.show_welcome_agent_hood = action.payload;
    },
    getPendingActions: (state, action) => {
      state.pendingActions = action.payload;
    },
    getSelectedAnnomlyPreview: (state, action) => {
      state.selectedAnnomly.preview = action.payload;
    },
    getAnnomlyDetails: (state, action) => {
      state.selectedAnnomly.details = action.payload;
    },
    getSelectedPlan: (state, action) => {
      state.selectedPlan = action.payload;
    },
    getSelectedApprovalRequestPreview: (state, action) => {
      state.selectedApprovalRequest.preview = action.payload;
    },
    getApprovalRequestDetails: (state, action) => {
      state.selectedApprovalRequest.details = action.payload;
    },
    getProcessList: (state, action) => {
      state.processList = action.payload;
    },
    getSelectedProcess: (state, action) => {
      state.selectedProcess = action.payload;
    },
    getAgentList: (state, action) => {
      state.agentList = action.payload;
    },
    getSelectedAgent: (state, action) => {
      state.selectedAgent = action.payload;
    },
    setRecentAgent: (state, action) => {
      state.recentAgents = state.recentAgents.filter(id => id !== action.payload);
      state.recentAgents.unshift(action.payload);
      if (state.recentAgents.length > 10) {
        state.recentAgents = state.recentAgents.slice(0, 10);
      }
    },
    clearRecentAgents: (state) => {
      state.recentAgents = [];
    },
    setBiPortalRecentMenus: (state, action) => {
      state.biPortalRecentMenu = action.payload;
    },
    setBiPortalAllModule: (state, action) => {
      state.biPortalAllMenu = action.payload;
    },
    setBiPortalBucketWithDashboard: (state, action) => {
      state.biPortalBucketWithDashboard = action.payload;
    },
    setBiPortalBucket: (state, action) => {
      state.biPortalBucket = action.payload;
    },
    setBiPortalDashboard: (state, action) => {
      state.biPortalDashboard = action.payload;
    },
    setBiPortalCanvas: (state, action) => {
      state.biPortalCanvas = action.payload;
    },
    setBiPortalCanvasTemplateID: (state, action) => {
      state.biPortalCanvasTemplateID = action.payload;
    },
  },
});

export const {
  getInsightList,
  getPinnedList,
  getPendingActions,
  getSelectedAnnomlyPreview,
  getSelectedPlan,
  getAnnomlyDetails,
  getSelectedApprovalRequestPreview,
  getApprovalRequestDetails,
  getProcessList,
  getSelectedProcess,
  getAgentList,
  getSelectedAgent,
  setRecentAgent,
  clearRecentAgents,
  setBiPortalRecentMenus,
  setBiPortalAllModule,
  setBiPortalBucketWithDashboard,
  setBiPortalBucket,
  setBiPortalDashboard,
  setBiPortalCanvas,
  setBiPortalCanvasTemplateID,
  setWelcomePreference,
} = biPortalSlice.actions;
export default biPortalSlice.reducer;
